import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Switch, Autocomplete, TextField, RadioGroup, FormControlLabel, Radio, Modal } from "@mui/material";
import { MdModeEditOutline, MdCategory } from "react-icons/md";
import { callAPI } from "../../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../../core/BaseComponents/Modal";
import { FaHotel } from "react-icons/fa";
import { getChainIdLS, isValidRole, ScrollToTop } from "../../../../../utils/utils";
import { faImages, faLink } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeletePartnerConfig from "./DeletePartnerConfig";
import EnableDisablePartnerConfig from "./EnableDisablePartnerConfig";
import Custom_Paingation from "../../../../core/BaseComponents/Custom_Paingation";
import DeleteBannerImage from "./DeleteBannerImage";
import CarouselComponent from "./CarouselComponent ";
import { useSelector } from "react-redux";
import ImageResolutionTooltip from "../../../ConfigurationNewHotel/ImageResolutionTooltip";
import CategoryConfiguration from "./CategoryConfiguration";
import { BsEye } from "react-icons/bs";
import ServicePreview from "./ServicePreview";

function HotelServiceConfiguration() {
  const [hotelServiceConfigList, setHotelServiceConfigList] = useState([]);
  const [confirmDeleteHotelRow, setConfirmDeleteHotelRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
  const [editHotelConfig, setEditHotelConfig] = useState(false);
  const [editHotelRowUpdate, setEditHotelRowUpdate] = useState(false);
  const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState('');
  const [editHotelSid, setEditHotelSid] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileError, setFileError] = useState("");
  const [fileImagesError, setFileImagesError] = useState("");
  const [file, setFile] = useState('');
  const [fileUrl, setFileUrl] = useState('');

  const [files, setFiles] = useState([]);
  const [fileUrls, setFileUrls] = useState([]);

  const [thumbnailImage, setThumbnailImage] = useState({});
  const [uploadedPictures, setUploadedPictures] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [previewBannerConfigIndex, setPreviewBannerConfigIndex] = useState(0);
  const [deleteBannerImagePopUpAPI, setDeleteBannerImagePopUpAPI] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [listConfigId, setListConfigId] = useState([]);
  const [initialSlide, setInitialSlide] = useState(0);
  const [upLoadedFilesLength, setUpLoadedFilesLength] = useState(0);
  // const [editBannerRowUpdate, setEditBannerRowUpdate] = useState(false);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const [categoryPopupOpen, setCategoryPopupOpen] = useState(false)
  const [categoryId, setCategoryId] = useState(null)

  const [preview, setPreview] = useState(false);
  const [previewListRowData, setPreviewListRowData] = useState({});

  const textPositionMaster = ["Top Left", "Top Right", "Bottom Left", "Bottom Right", "Centered", "Top Center", "Bottom Center"];
  
  const recordsPerPage = 10;
  const { chainId } = useSelector((state) => state.chainIdReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: { active: true, serviceType: "", }
  });

  const hotelServiceImages = [
    {
      name: "Hotel Service Image",
      files: 15,
      size: "700 KB",
      height: 1080,
      width: 1920,
      resolution: "72 PPI",
      aspect: "16:09",
      formats: "JPG, JPEG, PNG",
    }
  ]

  const thumbnailImageGuide = [
    {
      name: "Hotel Service Thumbnail Image",
      files: 1,
      size: "700 KB",
      height: 200,
      width: 500,
      resolution: "72 PPI",
      aspect: "16:09",
      formats: "JPG, JPEG, PNG",
    }
  ];

  let validPermissionClassName = isValidRole("HOTEL_SERVICES_MODIFY")
    ? ""
    : "btn-disable-permission";

  const textPostionClass = (selectedTextPosition) => {
    if (selectedTextPosition === "Top Left") {
      return 'top-left'
    } else if (selectedTextPosition === "Top Right") {
      return 'top-right'
    } else if (selectedTextPosition === "Centered") {
      return 'center'
    } else if (selectedTextPosition === "Bottom Right") {
      return 'bottom-right'
    }else if (selectedTextPosition === "Top Center") {
      return 'top-center'
    }else if (selectedTextPosition === "Bottom Center") {
      return 'bottom-center'
    }
    else if (selectedTextPosition === "Bottom Left") {
      return 'bottom-left'
    }
  }

  const onSubmit = (data) => {
  
    if (fileUrl === '') {
      setFileError('Hotel Service Thumbnail is required');
      return;
    }
    if (fileError !== "") {
      return;
    }
    if (data?.type === "UPLOAD_PICTURE" && watch('serviceType') !== "category") {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        let bytes = (file?.size / (1024)).toFixed(2);
        if (bytes > 700) {
          setFileImagesError(`Upload file should be less than 700KB`);
          return;
        }
      };
    }
    const formData = new FormData();
    let fileUrlText = fileUrls?.map(item => item.text);
    let fileUrlTextPosition = fileUrls?.map(item => item.textPosition);
    formData.append('imageText', fileUrlText);
    formData.append('textPositions', fileUrlTextPosition);
    let method = "POST";
    let url = `/speciality?menuName=${encodeURIComponent(data?.menuName)}&type=${data?.type}&link=${data?.link}&active=${data?.active}&serviceType=${data?.serviceType?data?.serviceType:""}`;
    if (editHotelRowUpdate) {
      let updatedText = JSON.stringify(fileUrls?.filter(item => item.id).map(item => ({ imageId: item.id, text: item.text, textPosition: item.textPosition })));
      fileUrlText = fileUrls?.filter(item => !item.id).map(item => item.text);
      fileUrlTextPosition = fileUrls?.filter(item => !item.id).map(item => item.textPosition);
      formData.delete('imageText');
      formData.delete('textPositions');
      formData.append('textUpdate', updatedText);
      formData.append('imageText', fileUrlText);
      formData.append('textPositions', fileUrlTextPosition);
      method = "PUT"
      url = `/speciality?id=${editHotelSid?.id}&menuName=${encodeURIComponent(data?.menuName)}&type=${data?.type}&link=${data?.link}&active=${data?.active?data?.active:false}&serviceType=${data?.serviceType?data?.serviceType:""}`;
      if (files.length + upLoadedFilesLength > 15) {
        setFileImagesError(`${upLoadedFilesLength === 15 ? "Delete any of banner image to upload new banner image" : `You can only upload up to ${15 - upLoadedFilesLength} banner images`}`);
        return;
      }
      setFileImagesError('');
    }
    else {
      if (data?.type === "UPLOAD_PICTURE" && watch('serviceType') !== "category") {
        if (files.length === 0) {
          setFileImagesError('You must upload at least 1 file');
          return;
        } else if (files.length > 15) {
          setFileImagesError('You can only upload up to 15 files');
          return;
        }
      }
    }
    setFileImagesError('');

    formData.append('menuImage', file);
    if (data?.type === "UPLOAD_PICTURE") {
      Array.from(files).forEach((file) => {
        formData.append('images', file);
      });
    }
    setLoader(true);
    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          menuName: '',
          active: true,
          link: '',
          type: ''
        });
        setFileUrl('');
        setFile('');
        setFiles([]);
        setFileUrls([]);
        setCreateHotelSuccessMsg(response?.message);
        hotelServiceListApi();
        setEditHotelSid('');
        setUpLoadedFilesLength(0);
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isHotelDeletedRef = useRef({
    isHotelDeletedModalData: null,
    userConformationModalData: null,
  });

  const isBannerImaageDeletedRef = useRef({
    isBannerImageDeletedModalData: null,
    deleteBannerConformationModalData: null
  });

  const deleteHotelConfigPopUpHandler = (row) => {
    setDeleteHotelPopUp(true);
    const newModalRefData = {
      isHotelDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isHotelDeletedRef.current = newModalRefData;
  }

  const deleteHotelHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteHotelRow === "") {
      return
    }

    if (confirmDeleteHotelRow === `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.menuName}`) {
      setConfirmValidate(false)
      const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
      callAPI(`delete-special?specialId=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isHotelDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isHotelDeletedRef.current = newModalRefData;
          setEditHotelSid({})
          hotelServiceListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      menuName: '',
      active: true,
      link: '',
      type: ''
    });
    setFileUrl('');
    setFile('');
  }

  // const renderActionCategory = (row) =>{
  //   return (
  //     !row?.active ? <>
  //     {row?.categoryType ? <Tooltip title="Edit" arrow>
  //         <MdCategory
  //           className="edit-icon-enable"
  //           onClick={() => { setCategoryPopupOpen(true); setCategoryId(row?.id) }}
  //         />
  //     </Tooltip>: <p>N.A</p>}
  //     </>
  //     :
  //     <>
  //       <Tooltip title="Disable to perform actions" arrow>
  //           <span><MdCategory className="edit-icon-disable" /></span>
  //       </Tooltip>
  //     </>
  //   )
  // }

  const renderActionIcon = (row) => {
    return (
      isValidRole("HOTEL_SERVICES_MODIFY")?<>
        {/* {!row?.active ? <><Tooltip title="Edit" arrow>
          <MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditHotelConfig(true); setEditHotelSid(row) }}
          />
        </Tooltip>
          <Tooltip title="Delete" className="cursor-pointer" arrow>
            <DeleteIcon
              className="delete-icon-enable"
              onClick={() => {
                deleteHotelConfigPopUpHandler(row);
              }}
            />
          </Tooltip></> :
          <>
            <Tooltip title="Disable to perform actions" arrow>
              <span><MdModeEditOutline className="edit-icon-disable" /></span>
            </Tooltip>
            <Tooltip title="Disable to perform actions" arrow>
              <DeleteIcon className="delete-icon-disable" />
            </Tooltip>
          </>
        } */}

        <EnableDisablePartnerConfig editHotelSid={editHotelSid} row={row} setLoader={setLoader} hotelServiceListApi={hotelServiceListApi} />
      </>:
          <>
            {/* <Tooltip title="Don't have permission to edit" arrow>
              <span><MdModeEditOutline className="edit-icon-disable" /></span>
            </Tooltip>
            <Tooltip title="Don't have permission to edit" arrow>
              <DeleteIcon className="delete-icon-disable" />
            </Tooltip> */}
            <Tooltip title="Don't have permission to edit">
                <span>
                <Switch
                name="active"
                disabled={true}
                // onChange={(event) => handleToggleChange(event, props?.row)}
                inputProps={{ "aria-label": "controlled" }}
                value={row.isActive}
                checked={row.isActive}
                className={`${row.isActive === false ? 'switchuser-inactive' : 'switchuser-active'}`}
                />
                </span>
        </Tooltip>
          </>
    );
  };

  const renderWebLink = (row) => {
    let link;
    if (row?.webLink !== null) {
      link = <Tooltip title={row?.webLink}>
        <a href={row?.webLink} target="_blank" rel="noopener noreferrer" className={`text-black d-block ${row?.webLink.length > 10 ? 'overflow-ellipsis' : ''}`}>{row?.webLink}</a>
      </Tooltip>
    } else if (row?.youtubeLink !== null) {
      link = <Tooltip title={row?.youtubeLink}>
        <a href={row?.youtubeLink} target="_blank" rel="noopener noreferrer" className={`text-black d-block ${row?.youtubeLink.length > 10 ? 'overflow-ellipsis' : ''}`}>{row?.youtubeLink}</a>
      </Tooltip>
    } else if (row?.categoryType) {
      link = <Tooltip title={row?.active?"Disable to perform action":""}>
        <span><button onClick={() => { setCategoryPopupOpen(true); setCategoryId(row?.id) }} className={`create-btn ${row?.active?"btn-disable-permission":""}`}>Add / Edit Category</button></span>
        </Tooltip>
    } else if (row?.imageResponse?.length) {
      link = <div className="delete-config-images">
        {row?.imageResponse?.slice(0, 4).map((url, index) => (
          <div className="me-2" key={url?.id}>
            <img src={url?.imageUrl} alt={url?.id} onClick={() => BannerPreviewHandler(row?.id, index)} />
            {/* <Tooltip title={`${row?.imageResponse?.length === 1 ? 'At least one image required in hero banner' : row?.active ? "Un-Publish to perform actions" : editHotelSid.id === row?.id ? "Cancel edit mode to perform actions" : 'Delete'}`}>
              <span className={`${row?.imageResponse?.length === 1 || row?.active || editHotelSid.id === row?.id ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => row?.imageResponse?.length === 1 || row?.active || editHotelSid.id === row?.id ? "" : handleDeleteBannerAPI(url, row?.id)}>X</span>
            </Tooltip> */}
            {/* : <Tooltip title="Un-Publish to perform actions">
              <span className="cross-mark-disabled">X</span>
            </Tooltip> */}
          </div>
        ))}
        {row?.imageResponse?.length>4 && <span>...<span onClick={() => BannerPreviewHandler(row?.id, 0)} className="ms-2 cdsn-count">+{row?.imageResponse?.length-4}</span></span>}
      </div>
    }
    return link
  }

  const previewHandler = (row) => {
    setPreviewListRowData(row);
    setPreview(true);
  }

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "menuName", headerName: "Service Name", flex: 1 },
    { field: 'menuImageUrl', headerName: 'Service Thumbnail', flex: 1, row: true, renderCell: (row) => (<img src={row?.menuImageUrl} alt={row?.id} className="hero-config-img" />), disableSortIcon: true, },
    { field: 'webLink', headerName: 'Service Details', flex: 1, row: true, renderCell: renderWebLink, disableSortIcon: true, },
    { field: "Preview", headerName: "Category Preview", flex: 1, disableSortIcon: true, row: true, renderCell: (row) => row?.hasCategories?<div className="rail-list-preview-eye" onClick={() => previewHandler(row)}><BsEye /></div>: <p>N.A</p> },
    // {
    //   field: "actionCell",
    //   row: true,
    //   headerName: "Actions",
    //   flex: 0.5,
    //   renderCell: renderActionIcon,
    //   sortDirection: false,
    //   disableSortIcon: true,
    // },
  ];

  const hotelServiceListApi = () => {
    const apiPath = `/speciality/all?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/speciality/all?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {}, { chainId: getChainIdLS() })
      .then((response) => {
        const temp = response?.hotelSpecialResponse?.filter((data)=>data?.active)
        setHotelServiceConfigList(temp)
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
      })
      .catch((err) => {
        console.warn(err.message)
      });
  };

  useEffect(() => {
    hotelServiceListApi();

    callAPI('/speciality-dropdown', "GET")
      .then((response) => {
        setServiceTypes(response)
      })
      .catch((err) => console.warn(err.message));
      cancelHotelHandler()
  }, [selectedPage, chainId]);


  const popupCloseHandler = () => {
    setDeleteHotelPopUp(false);
    setDeleteBannerImagePopUpAPI(false);
  };


  useEffect(() => {
    if (editHotelConfig) {
      getHotelListSidHandler();
      setEditHotelConfig(false);
    }
    ScrollToTop();
    setFileError('');
  }, [editHotelConfig, chainId]);

  const getHotelListSidHandler = () => {
    setLoader(true);
    callAPI(`/speciality-id?id=${editHotelSid?.id}`, "GET")
      .then(function (response) {
        setLoader(false);
        const payload = {
          menuName: response?.menuName,
          active: response?.active,
          link: response?.link,
          type: response?.serviceType,
          serviceType: response?.categoryType?response?.categoryType:""
        };
        setFileUrl(response?.menuImageUrl);
        setUpLoadedFilesLength(response?.imageResponse?.length);
        setFileUrls(response?.imageResponse?.map(item => ({ ...item, text: item.text ? item.text : ' ', delete: false })));
        reset(payload);
        setThumbnailImage(response?.menuImageUrl)
        setUploadedPictures(response?.imageResponse?.map(item => ({ ...item, text: item.text ? item.text : ' ', delete: false })))
        setEditHotelRowUpdate(true);
        setPreviewBannerConfigIndex(0)
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrl(thumbnailImage);
    setFileUrls(uploadedPictures);
    setFileError('');
  }

  const cancelHotelHandler = () => {
    reset({
      menuName: '',
      active: true,
      link: '',
      type: ''
    });
    setFileUrl('');
    setFile('');
    setFiles([]);
    setFileUrls([]);
    setEditHotelRowUpdate(false);
    setEditHotelSid('');
    setEditHotelConfig(false);
    setUpLoadedFilesLength(0);
  }

  const handleSwitchChange = (checked) => {
    setValue("active", checked);
  };

  const uploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setFileError('Upload file should be less than 700KB');
      return;
    }
    setFile(fileList);
    setFileError('');
  }
  const uploadImagesOrDragFileHandler = (fileList) => {
    const selectedFiles = Array.from(fileList);
    setFiles((prev) => [...selectedFiles, ...prev]);
    const urls = [];
    selectedFiles.map((file) => urls.push({ imageUrl: URL.createObjectURL(file), delete: true, text: ' ' }));
    setFileUrls((prev) => [...urls, ...prev]);
    // setFileError('');
  }

  const handleDeleteBanner = (index) => {
    // Revoke the object URL for the deleted file
    URL.revokeObjectURL(fileUrls[index]);
    // console.log(index)
    // Update the state
    // console.log(files);
    // console.log(fileUrls);
    const newFiles = files.filter((_, i) => i !== index);
    const newFileUrls = fileUrls.filter((_, i) => i !== index);
    setPreviewBannerConfigIndex(index ? index - 1 : 0);
    // console.log(newFiles)
    // console.log(newFileUrls)
    setFiles(newFiles);
    setFileUrls(newFileUrls);
  };

  const deleteLogoHandler = () => {
    setFile('');
    setFileUrl('');
    setFileError('');
  };

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const handleDeleteBannerAPI = (banner, bannerConfigId) => {
    setDeleteBannerImagePopUpAPI(true);
    const newModalRefData = {
      isBannerImageDeletedModalData: {
        bannerImage: banner,
        bannerConfigId: bannerConfigId
      },
      deleteBannerConformationModalData: null
    };
    isBannerImaageDeletedRef.current = newModalRefData;
  }

  const deleteBannerImageHandlerApi = () => {
    const { bannerImage, bannerConfigId } = isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData;
    callAPI(`/speciality/img?id=${bannerConfigId}&imageId=${bannerImage?.id}`, "DELETE", {}, { chainId: getChainIdLS() })
      .then((response) => {
        let successMessage = response.message
        const newModalRefData = {
          isBannerImageDeletedModalData: null,
          deleteBannerConformationModalData: {
            successMessage
          },
        };
        isBannerImaageDeletedRef.current = newModalRefData;
        hotelServiceListApi();
      })
      .catch((error) => {
        console.warn(error)
      });
  }

  const BannerPreviewHandler = (configId, index) => {
    setShowPreviewPopUp(true);
    setListConfigId(configId);
    setInitialSlide(index)
  }

  const handleTextChange = (e, input) => {
    if(input === "text"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, text: e.target.value, textPosition: item?.textPosition?.length > 2 ? item?.textPosition : 'Centered' } : item
        )
      );
    }
    else if (input === "textPosition"){
      setFileUrls(prev =>
        prev.map((item, index) =>
          index === previewBannerConfigIndex ? { ...item, textPosition: e } : item
        )
      );
    }
    
  }

  const categoryPopupCloseHandler = ()=>{
    setCategoryId(null)
    setCategoryPopupOpen(false)
    hotelServiceListApi()
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editHotelRowUpdate ? 'Edit Hotel Service Configuration' : 'Hotel Service Configuration'}</p>
            </div>
            <div className="col-6">
              <div className="form-group-hotel">
                <div className="floating-label">
                  <FaHotel className="new-hotel-icons" />
                  <input
                    id="menuName"
                    maxLength={25}
                    placeholder=""
                    {...register("menuName", {
                      required: "Hotel Service Title Required",
                    })}
                  />
                  <label htmlFor="menuName">Hotel Service Title</label>
                </div>
                {errors.menuName && (
                  <small className="required">{errors.menuName.message}</small>
                )}
              </div>
              <div className="form-group-hotel">
                <div className="floating-select-label">
                  <Controller
                    name="type"
                    control={control}
                    rules={{
                      validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select service type',
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                        disablePortal
                        options={serviceTypes}
                        getOptionLabel={(option) => option.replace('_', ' ').toLowerCase()}
                        onChange={(_, newValue) => {
                          field.onChange(newValue);
                        }}
                        value={field.value || ''}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            variant="outlined"
                            label="Hotel Service Category"
                            InputLabelProps={{
                              shrink: false,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </div>
                {errors.type && (
                  <small className="required">{errors.type?.message}</small>
                )}
              </div>

              {watch('type') !== "UPLOAD_PICTURE" && watch('type') && <div className="form-group-hotel">
                <div className="floating-label">
                  <FontAwesomeIcon icon={faLink} className="new-hotel-icons" />
                  <input
                    id="link"
                    placeholder=""
                    {...register("link", {
                      required: "Hotel Service URL is required",
                      pattern:watch('type') === "WEB_LINK"? {
                        value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{1,}(\S*)$/,
                        message: "URL must start with http://www. or https://www.",
                      }:watch('type') === "YOUTUBE_LINK"&& {
                        value: /^(https?:\/\/(www\.)?youtube\.com\/|https?:\/\/youtu\.be\/)/,
                        message: "URL must start with https://www.youtube.com/ or https://youtu.be/",
                      }
                    })}
                  />
                  <label htmlFor="link">Hotel Service URL</label>
                </div>
                {errors.link && (
                  <small className="required">{errors.link.message}</small>
                )}
              </div>}
              <div className="d-flex">
                {/* <div className="status-switch col-6">
                  <p className="mb-0">Hotel Service Status</p>
                  <label htmlFor="active">{!watch("active") || watch('serviceType')==="category" ? "Disabled" : "Enabled"}</label>
                  <Tooltip title={`${watch('serviceType')==="category" && !editHotelSid?.hasCategories ? "Service can be enabled after adding Category.":""}`} arrow placement="right"><span><Switch
                    id="active"
                    className={`form-control border-0 ${!watch("active") || (watch('serviceType')==="category" && !editHotelSid?.hasCategories)
                      ? "switchuser-inactive"
                      : "switchuser-active"
                      }`}
                    checked={watch("active") && (watch('serviceType')!=="category" || editHotelSid?.hasCategories)}
                    disabled={watch('serviceType')==="category" && !editHotelSid?.hasCategories ?true:false}
                    onChange={handleSwitchChange}
                    {...register("active")}
                  /></span>
                  </Tooltip>
                </div> */}
                {watch('type') === "UPLOAD_PICTURE" && <div className="col-6">
                  <Controller
                    name="serviceType"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <RadioGroup
                        row
                        value={field.value}   // <-- explicitly set value
                        onChange={field.onChange} // <-- explicitly handle onChange
                        className="h-auto main-events mt-0 mb-1"
                      >
                        <FormControlLabel
                          value=""
                          control={<Radio />}
                          label="Individual Service"
                        />
                        <FormControlLabel
                          value="category"
                          control={<Radio />}
                          label="Service Category"
                        />
                      </RadioGroup>
                    )}
                  />
                </div>}
              </div>
              
              {/* <div className="form-group-hotel">
                <div className="floating-label">
                  <FaFileUpload className="new-hotel-icons" />
                  <div>
                    <input
                      id='logos'
                      accept="image/*"
                      type="file"
                      placeholder=""
                      {...register("logos", {
                        required: "Enter Url",
                      })}
                      className="upload-logo"
                    />
                  </div>
                  <span htmlFor="logos" className="browse-content">Upload your logos here</span>
                </div>
                {errors.logos && (
                  <small className="required">{errors.logos.message}</small>
                )}
              </div> */}
            </div>
            <div className="col-6">
              {fileUrl !== "" ? <div className="partner-logo">
                <img src={fileUrl} alt={fileUrl} />
                <span onClick={() => deleteLogoHandler()}>X</span>
              </div>
                : <FileUploader
                  name="file"
                  types={["JPG", "PNG", 'JPEG']}
                  handleChange={uploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop image or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Thumbnail Image</span> here. 
                        <ImageResolutionTooltip position="left" data={thumbnailImageGuide}/>
                      </p>
                      {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                    </>
                  }
                />
              }

              {fileError && <p className="required">{fileError}</p>}
            </div>
            {watch('type') === "UPLOAD_PICTURE" && watch('serviceType') !== "category" && <div className="form-group-hotel col-12">
              <p className="banner-title">Hotel Service Images</p>
              <div className="row mx-0">
                {fileUrls?.length > 0 && <div className="col-9 upload-img">
                  <img src={fileUrls[previewBannerConfigIndex]?.imageUrl} alt={fileUrls[previewBannerConfigIndex]?.imageUrl} />
                  <p className={textPostionClass(fileUrls[previewBannerConfigIndex]?.textPosition)}><label>{fileUrls[previewBannerConfigIndex]?.text}</label></p>
                </div>
                }
                <div className={`${fileUrls.length > 0 ? 'col-3 file-upload-bg' : 'col-12 file-upload'}`}>
                  <FileUploader
                    name="file"
                    types={["JPG", "PNG", 'JPEG']}
                    multiple={true}
                    handleChange={uploadImagesOrDragFileHandler}
                    classes="drag-file"
                    children={
                      <>
                        <FontAwesomeIcon icon={faImages} className="fa-lg" />
                        <p className="drag-text">
                          Drag and drop your images here, or
                          <span> Browse</span>
                          <br />
                          To {editHotelRowUpdate ? 'Add New' : 'Upload'} Hotel Service Images.<ImageResolutionTooltip position="left" data={hotelServiceImages}/>
                        </p>
                        {/* <h6>Max file allowed : 15 {fileError===""&&"and Max File Size: 700 KB"} <br /> Formats Supported : JPG, JPEG and PNG</h6> */}
                      </>
                    }
                  />
                  {fileImagesError && <p className="required">{fileImagesError}</p>}
                </div>
                <div className="upload-img_url ps-0">
                    {fileUrls?.map((url, index) =>
                      <div key={index}>
                        <img src={url?.imageUrl} alt={url?.imageUrl} onClick={() => setPreviewBannerConfigIndex(index)} className={`${fileUrls[previewBannerConfigIndex] === url ? 'selected-image' : ''}`} />
                        {url?.delete && <span onClick={() => handleDeleteBanner(index)}>X</span>}
                      </div>
                    )}
                  </div>
                {fileUrls?.length > 0 && <div className="mt-3">
                  {fileUrls?.map((url, index) =>
                    <>
                      {fileUrls[previewBannerConfigIndex] === url &&
                        <div className="form-group-hotel d-flex">
                          <div key={index} className="floating-label col-4 me-3">
                            <input
                              type="text"
                              value={url.text}
                              id={url.id}
                              maxLength={300}
                              placeholder=""
                              onChange={(e)=>handleTextChange(e, "text")}
                            />
                            <label>Optional Image Text</label>
                          </div>
                          <div className="floating-select-label col-3">
                              <Controller
                                name="textPosition"
                                control={control}
                                // rules={{
                                //   validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please Select Text Position'
                                // }}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    disableClearable
                                    className={`multiselectlist ${url?.textPosition && url?.textPosition.length > 0 ? 'Mui-focused' : ''}`}
                                    // limitTags={2}
                                    disablePortal
                                    // multiple
                                    options={textPositionMaster}
                                    getOptionLabel={(option) => option.toString()}
                                    onChange={(_, newValue) => {
                                      field.onChange(newValue);
                                      handleTextChange(newValue, "textPosition")
                                    }}
                                    value={url.textPosition ? url.textPosition : ' '}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder=""
                                        variant="outlined"
                                        label="Select Text Position"
                                        InputLabelProps={{
                                          shrink: false,
                                        }}
                                      />
                                    )}
                                  />
                                )}
                              />
                            </div>
                        </div>}
                    </>
                  )}
                </div>}
              </div>
            </div>}
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>{editHotelRowUpdate ? "Cancel" : "Clear All"}</button>
            {editHotelRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            <button type="submit" className={`create-btn ${validPermissionClassName} `}>{editHotelRowUpdate ? "Update" : "Create"}</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Service Configuration List</b></p>

          <TableWrapper
            data={hotelServiceConfigList}
            columns={columns}
            noPagination={true}
            module="partner-config"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      <CategoryConfiguration categoryPopupOpen = {categoryPopupOpen} categoryId={categoryId} categoryPopupCloseHandler={categoryPopupCloseHandler}/>
      {deleteHotelPopUp && <DeletePartnerConfig
        deleteHotelPopUp={deleteHotelPopUp}
        isHotelDeletedRef={isHotelDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deleteHotelHandler={deleteHotelHandler}
        setConfirmDeleteHotelRow={setConfirmDeleteHotelRow}
        confirmDeleteHotelRow={confirmDeleteHotelRow}
        confirmValidate={confirmValidate}
      />}
      <DeleteBannerImage
        deleteBannerImagePopUp={deleteBannerImagePopUpAPI}
        popupCloseHandler={popupCloseHandler}
        deleteBannerImageHandlerApi={deleteBannerImageHandlerApi}
        isBannerImaageDeletedRef={isBannerImaageDeletedRef}
      />
      {showPreviewPopUp && <CarouselComponent
        showPreviewPopUp={showPreviewPopUp}
        editHotelSid={editHotelSid}
        listConfigId={listConfigId}
        setShowPreviewPopUp={setShowPreviewPopUp}
        initialSlide={initialSlide}
        hotelServiceListApi={hotelServiceListApi}
        handleDeleteBannerAPI={handleDeleteBannerAPI}
      />}
      <Modal
          open={preview}
          onClose={()=>setPreview(false)}
          className="basic-modal"
        >
          <ServicePreview closePreview={()=>setPreview(false)} previewListRowData={previewListRowData}/>
      </Modal>
      <BasicModal
        popupOpen={createHotelSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateHotelSuccessMsg(''); setEditHotelRowUpdate(false); hotelServiceListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default HotelServiceConfiguration;